/**
 * React Query client for ChapterBuild's frontend.
 *
 * 5-minute default stale time matches the server's `Cache-Control: max-age=300`
 * on `/api/c/:slug/tenant-config`. Refetch on window focus disabled — too
 * jumpy for the Cabinet member dashboard use case.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
